// extracted by mini-css-extract-plugin
module.exports = {"loader":"_4kZPe","rotate-ltr":"_27PR9","rotateLtr":"_27PR9","rotate-rtl":"_1cKBR","rotateRtl":"_1cKBR"};